import { Ban, Sparkles, Scale, Zap } from "lucide-react";
import type { LucideIcon } from "lucide-react";

export interface TrustBadge {
  icon: LucideIcon;
  labelKey: string;
}

// Trust badges rendered inside the hero's glass pill. Lives next to LandingHero
// because that's the only consumer. (Previously under TrustBar/, which was
// otherwise unreferenced — see git history.)
export const TRUST_BADGES: TrustBadge[] = [
  { icon: Ban, labelKey: "trustBadgeNoWatermarks" },
  { icon: Sparkles, labelKey: "trustBadge4K" },
  { icon: Scale, labelKey: "trustBadgeCommercial" },
  { icon: Zap, labelKey: "trustBadgeSpeed" },
];
